import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { CreateEditUsageEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { ItemGridFormField } from 'Components';
import { InputField } from 'Common/SemanticWrapper';

const PreviewUsageComponent = props => {
  const {
    usageItemsInfo,
    resetPageOnDataChange,
    onResetPageOnDataChange,
  } = props;

  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={3}>
            <Field
              name={CreateEditUsageEnum.Comments}
              component={InputField}
              type="text"
              maxLength={50}
              label={'Comments'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <label className={'text-orange'}>Usage Items</label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <hr />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={ItemGridFormField}
              name={CreateEditUsageEnum.UsageItemsInfo}
              {...{
                dataSource: usageItemsInfo,
                isPreviewPage: true,
                gridName: GridEnum.INV_UsageList_CreateEdit_View,
                tableName: TableNamesEnum.USAGE_LIST_CREATE_EDIT_TABLE,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

PreviewUsageComponent.propTypes = {
  usageItemsInfo: PropTypes.array,
  resetPageOnDataChange: PropTypes.bool,
  onResetPageOnDataChange: PropTypes.func,
};

PreviewUsageComponent.defaultProps = {
  usageItemsInfo: [],
  resetPageOnDataChange: true,
  onResetPageOnDataChange: () => {},
};
export default PreviewUsageComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/components/createEditUsage/PreviewUsage.js